import { useEffect, useMemo } from 'react';
export function useAbortOnUnmount() {
    const abortController = useMemo(() => new AbortController(), []);
    useEffect(() => () => abortController.abort('UNMOUNT'), [abortController]);
    return abortController.signal;
}
